// extracted by mini-css-extract-plugin
export default {"container":"CustomerPortalLink_container__BgCvL"};